export const Dashboard = () => (
  <div>
    <h2>Dashboard</h2>
  </div>
);
